import { useOnDemandGetAddressFromCep } from './useOnDemandGetAddressFromCep';

export default useOnDemandGetAddressFromCep;
